export default "__VITE_ASSET__D3VzPU$k__"